import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useEffect, useState } from "react";
import BasicButton from "./BasicButton";

export default function BasicCondInput(props: BasicCondInputProps) {
  const { onchange, onWheel, type:  tempType } = props;
  const conditions = props.conditions || [];
  const [cond, setCond] = useState(props.cond || conditions[0]);
  const [index, setIndex] = useState(0);
  const [val, setVal] = useState<string | number | undefined>(props.val);
  const { type, min, max } = cond || {};

  useEffect(() => {
    props.cond && setCond(props.cond);
  }, [props.cond]);

  function handleChange(val: string | number) {
    setVal(val);
    if (onchange) onchange({ val, cond });
  }

  function handleCondChange() {
    let i = index + 1;
    if (i === conditions.length) i = 0;
    const cond = conditions[i];
    setCond(cond);
    setIndex(i);

    if (onchange) onchange({ val, cond });
  }

  function Cond(props: { conditions: Cond[] }) {
    const { conditions } = props;
    if (!cond || conditions.length === 0) return <></>;
    const c = conditions.find((x) => x.value === cond.value) || cond;
    return (
      <BasicButton
        style={{ minWidth: 32, minHeight: 32 }}
        onClick={handleCondChange}
        className="p-0 flex justify-center items-center text-xs"
        variant="outlined"
      >
        {c?.label}
      </BasicButton>
    );
  }

  return (
    <BasicTextInput
      prefix={<Cond {...{ conditions }} />}
      onChange={handleChange}
      onWheel={onWheel}
      {...props}
      {...{ type: tempType || type, min, max }}
      style={{ padding: "4px 4px 4px 4px", alignItems: "center", minWidth: 100, ...props.styles }}
    />
  );
}
